import { render } from "./ctcp.vue?vue&type=template&id=07362ba8&ts=true"
import script from "./ctcp.vue?vue&type=script&lang=ts"
export * from "./ctcp.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/ctcp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07362ba8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07362ba8', __exports__)) {
    api.reload('07362ba8', __exports__)
  }
  
  module.hot.accept("./ctcp.vue?vue&type=template&id=07362ba8&ts=true", () => {
    api.rerender('07362ba8', render)
  })

}


export default __exports__